export enum ApiCredentialExpiryDuration {
  OneMonth = 'oneMonth',
  ThreeMonths = 'threeMonths',
  SixMonths = 'sixMonths',
  OneYear = 'oneYear',
}
